import { render, staticRenderFns } from "./SurveyQuestionTypePicker.vue?vue&type=template&id=2658aae6&"
import script from "./SurveyQuestionTypePicker.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports